export class Category {
    constructor() {
        this.name = '';
        this.background = '';
        this.video = '';
    }
}